import * as Blockly from "blockly";
import { registerMutatorIfMissing } from "./blockly-field-factory.ts";

const ListJoinMutatorMixin: any = {
  itemCount_: 0,

  saveExtraState: function (): { itemCount: number } {
    return { itemCount: this.itemCount_ };
  },

  loadExtraState: function (state: { itemCount?: number } | null): void {
    this.itemCount_ = state?.itemCount ?? 0;
    this.updateShape_();
  },

  decompose: function (workspace: Blockly.WorkspaceSvg): Blockly.BlockSvg {
    const containerBlock = workspace.newBlock("list_join_container") as Blockly.BlockSvg;
    containerBlock.initSvg();
    let connection = containerBlock.getInput("STACK")?.connection;
    for (let i = 0; i < this.itemCount_; i++) {
      const itemBlock = workspace.newBlock("list_join_item") as Blockly.BlockSvg;
      itemBlock.initSvg();
      connection?.connect(itemBlock.previousConnection);
      connection = itemBlock.nextConnection;
    }
    return containerBlock;
  },

  compose: function (containerBlock: Blockly.Block): void {
    let itemBlock = containerBlock.getInputTargetBlock("STACK");
    const connections: Array<Blockly.Connection | null | undefined> = [];
    while (itemBlock) {
      connections.push((itemBlock as any).valueConnection_);
      itemBlock = itemBlock.nextConnection?.targetBlock() ?? null;
    }
    this.itemCount_ = connections.length;
    this.updateShape_();
    for (let i = 0; i < this.itemCount_; i++) {
      if (connections[i]) this.getInput("ADD" + i)?.connection?.connect(connections[i]!);
    }
  },

  saveConnections: function (containerBlock: Blockly.Block): void {
    let itemBlock = containerBlock.getInputTargetBlock("STACK");
    let i = 0;
    while (itemBlock) {
      const input = this.getInput("ADD" + i);
      (itemBlock as any).valueConnection_ = input?.connection?.targetConnection;
      i++;
      itemBlock = itemBlock.nextConnection?.targetBlock() ?? null;
    }
  },

  updateShape_: function (): void {
    let i = 0;
    while (this.getInput("ADD" + i)) {
      this.removeInput("ADD" + i);
      i++;
    }
    for (let j = 0; j < this.itemCount_; j++) {
      const input = this.appendValueInput("ADD" + j).setAlign(Blockly.inputs.Align.RIGHT);
      if (j === 0) input.appendField("Element");
    }
  },
};

let registered = false;

export function registerListJoinMutator(): void {
  if (registered) return;
  registered = true;

  if (!Blockly.Blocks["list_join_container"] || !Blockly.Blocks["list_join_item"]) {
    Blockly.defineBlocksWithJsonArray([
      {
        type: "list_join_container",
        message0: "Elemente %1 %2",
        args0: [
          { type: "input_dummy" },
          { type: "input_statement", name: "STACK" },
        ],
        colour: 260,
        tooltip: "",
        enableContextMenu: false,
      },
      {
        type: "list_join_item",
        message0: "Element",
        previousStatement: null,
        nextStatement: null,
        colour: 260,
        tooltip: "",
        enableContextMenu: false,
      },
    ]);
  }

  registerMutatorIfMissing("list_join_mutator", ListJoinMutatorMixin, undefined, ["list_join_item"]);
}
